import helpTemplate from 'views/states/help.html';

export class HelpComponent implements ng.IComponentOptions {
  public templateUrl: string;

  constructor() {
    this.templateUrl = helpTemplate;
  }
}
